export const BOOT_RETRY_ATTEMPTS = 3
export const BOOT_RETRY_DELAY = 2000
